export default {
  common: {
    appName: '蜜獾娛樂',
    confirm: '確認',
    cancel: '取消',
    submit: '送出',
    save: '儲存',
    usernameRequired: '請輸入使用者名稱！',
    passwordRequired: '請輸入密碼！',
    viewMore: '查看更多',
    refreshSuccess: '刷新成功',
    noMore: '沒有更多了',
    emptyData: '暫無數據',
  },
  footer: { home: '首頁', lottery: '彩券', game: '預約', video: '影片', mine: '我的' },
  lang: { title: '語言 / Language', current: '當前語言' },
  home: {
    recommendedTasks: '推薦任務',
    popularRanking: '人氣排行',
    hotRecommend: '熱門推薦',
    playCount: '播放:{count}',
    noticeLoading: '取得中......',
  },
  game: {
    hallTitle: '預約大廳',
    categoryAll: '全部',
  },
  choose: {
    title: '選妃',
    tabCities: '城市大全',
    tabProcess: '流程價格',
    privacyNotice: '本平台全網最真實外圍+商務伴遊+同城激情，為保證每個用戶的個人隱私，客戶僅限通過聯繫接待員或平台資深會員實名推薦才可加入。',
    resourcesQ: '有哪些資源?',
    resourcesA: '網紅、模特、空姐、嫩模、大學生，只有您想不到，沒有本平台辦不到',
    scopeQ: '服務範圍?',
    scopeA: '同城免費約砲，任意地點全國空降，國內一二線城市當地均有，三線城市也可通過聯繫接待員預約安排。',
    book: '預約',
    contactConcierge: '請聯繫顧問或接待員',
    cityNames: {
      beijing: '北京',
      shanghai: '上海',
      guangzhou: '廣州',
      shenzhen: '深圳',
      nanjing: '南京',
      changsha: '長沙',
      chongqing: '重慶',
      xian: '西安',
    },
  },
  lottery: {
    gameRecord: '任務記錄',
    orderList: '任務單',
    orderItemDetail: '1注X{money}元={money}元',
    clearOrder: '清空訂單',
    confirmSubmit: '確認提交',
    availableBalance: '可用餘額',
    yuan: '元',
    currentPick: '當前選號：',
    amountPerBet: '每注金額：',
    amountPlaceholder: '請輸入金額',
    amountInvalid: '金額錯誤！',
    fillAmount: '請填寫金額！',
    selectNumberFirst: '請選號！',
    insufficientBalance: '餘額不足，請聯繫客服充值！',
    notSelected: '未選中',
    contactAdminForTask: '請聯繫管理員領取該任務！',
    drawSuccess: '開獎成功，期號：{expect}',
    periodNumber: '期號',
    betUnit: '注',
    totalAmountLabel: '總金額：',
    totalCountLabel: '總注數：',
    drawResult: '開獎號碼',
    big: '大',
    small: '小',
    single: '單',
    doubleNum: '雙',
    rules: {
      title: '玩法規則',
      tipTitle: '玩法提示',
      tipDetail: '從可選和值形態裡面選擇號碼進行下注',
      winTitle: '中獎說明',
      winDetail: '三個開獎號碼總和值11~18 為大;總和值3~ 10為小;',
      exampleTitle: '投注範例',
      exampleDetail: '投注方案：小 開獎號碼：123,即中小',
    },
  },
  mine: {
    accountDetail: {
      kind: { recharge: '儲值', withdraw: '提現', game: '投注' },
    },
    withdraw: {
      amountLabel: '提現金額 (元)',
      all: '全部',
      limitRule1: '1.單筆限額：最低{min}元，最高{max}元',
      limitRule2: '2.提現次數：一天最高提現{num}次',
      limitRule3: '3.到賬時間：一般到賬時間在5分鐘左右，最快2分鐘內到賬',
      limitTitle: '限額說明',
      balanceLabel: '餘額：',
      submit: '馬上提現',
      amountInvalid: '請填寫正確的金額',
    },
    bindCard: {
      formLabel: '請輸入您的收款卡信息',
      bankidLabel: '銀行卡號',
      bankidPlaceholder: '請輸入真實銀行卡號',
      bankLabel: '銀行名稱',
      bankPlaceholder: '請選擇銀行',
      notice: '尊敬的用戶,為了保障您的資金安全,請您綁定您的真實姓名和設置取款密碼,如果姓名與開戶名不一致,將無法取款',
      submit: '確認綁卡',
      bankidRequired: '請輸入銀行卡號！',
      bankRequired: '請選擇銀行！',
    },
    setbank: {
      title: '收款卡信息',
      addCard: '添加收款卡',
      tips: '提示:請綁定大型商業銀行,如需修改,請您聯繫在線客服',
      setNameFirst: '請設置姓名後再綁定銀行卡！',
      setPayPasswordFirst: '請設置提現密碼後再綁定銀行卡！',
    },
    setPayPassword: {
      firstPrompt: '請輸入資金密碼',
      secondPrompt: '請再次輸入資金密碼',
      incomplete: '請填寫完整',
      mismatch: '兩次密碼不一致！',
    },
    setLoginPassword: {
      oldPassword: '舊密碼',
      oldPasswordPlaceholder: '請輸入您的舊密碼',
      newPassword: '新密碼',
      newPasswordPlaceholder: '請輸入您的新密碼',
      confirmPasswordPlaceholder: '請再次輸入您的新密碼',
      incomplete: '請填寫完整！',
      mismatch: '兩次密碼輸入不一致',
    },
    setname: {
      nameLabel: '姓名',
      namePlaceholder: '請輸入真實姓名',
      notice: '為了您賬戶安全,真實姓名需要與綁定銀行卡姓名一致',
      alreadySet: '請勿重複設置！',
      nameRequired: '請輸入姓名！',
    },
    setsex: {
      male: '男',
      female: '女',
    },
    infomation: {
      avatar: '頭像',
      chooseAvatar: '選擇頭像',
      realName: '真實姓名',
      notSet: '未設置',
      gender: '性別',
      unknown: '未知',
      bindInfo: '綁定信息',
      bound: '已綁定',
      none: '無',
    },
    index: {
      recharge: '充值',
      withdraw: '提現',
      myWallet: '我的錢包',
      details: '明細',
      balanceLabel: '餘額：',
      personalReport: '個人報表',
      accountDetail: '帳號明細',
      profileCenter: '個人中心',
      notice: '資訊公告',
      customerService: '線上客服',
      completeTaskFirst: '請先完成註冊任務',
      contactServiceToRecharge: '請聯繫線上客服充值',
      setPayoutCardFirst: '請先設定收款卡',
      featureDisabled: '該功能暫未開放',
      accountOffline: '帳號下線',
      loginRegister: '登入/註冊',
      loginHint: '登入後查看',
    },
    setting: {
      basicInfo: '基本資訊',
      loginPassword: '登入密碼',
      payPassword: '支付密碼',
      payPasswordAlreadySet: '支付密碼已設定！',
      signOut: '登出',
    },
    gameRecord: {
      betAmount: '下注金額：{money}',
      betTime: '下注時間：{time}',
      settleTime: '結算時間：{time}',
    },
    withdrawRecord: {
      amount: '提現金額：{money}',
      desc: '提現說明：{desc}',
      submitTime: '申請時間：{time}',
      reviewTime: '審核時間：{time}',
    },
    report: {
      profitLabel: '盈虧',
      formulaTip: '盈虧 = 中獎金額 - 投注金額 + 充值 - 提現',
      playAmount: '投注金額',
      rechargeAmount: '充值金額',
      withdrawAmount: '提現金額',
      winAmount: '中獎金額',
    },
    service: {
      contact: '立即諮詢',
      slogan: '有任何問題都可以聯繫我們',
    },
  },
  video: {
    hallTitle: '視頻影院',
    hotRecommend: '熱門推薦',
    playCount: '播放:{count}',
    playCountSuffix: '{count}次播放',
    rechargeToWatch: '請充值後觀看視頻！',
  },
  recharge: {
    title: '儲值',
    chooseCoin: '選擇幣種',
    address: '收款地址',
    copy: '複製地址',
    copied: '已複製',
    amount: '儲值金額',
    uploadShot: '上傳轉帳截圖',
    submit: '提交儲值申請',
    pending: '待審核',
    done: '已入帳',
    rejected: '已駁回',
  },
  payMethod: {
    title: '選擇收款方式',
    bankCard: '銀行卡',
    wallet: '加密錢包',
    unbind: '解綁',
    bindNew: '綁定新地址',
    confirmUnbind: '確認解綁該收款方式？',
    payPassword: '提現密碼',
    wrongPassword: '提現密碼錯誤',
    chooseFirst: '請先選擇收款方式',
  },
  router: {
    Index: { title: '首頁' },
    Home: { title: '首頁' },
    Choose: { title: '選妃' },
    List: { title: '選妃列表' },
    Profile: { title: '選妃詳情' },
    Mine: { title: '我的' },
    Video: { title: '影片' },
    Game: { title: '遊戲' },
    Login: { title: '登入' },
    Register: { title: '註冊' },
    ServiceOnline: { title: '線上客服' },
    ServicePage: { title: '線上客服' },
    Setting: { title: '設定' },
    Infomation: { title: '基本資訊' },
    Setname: { title: '修改真實姓名' },
    Setsex: { title: '修改性別' },
    SetPayPassword: { title: '付款密碼管理' },
    SetLoginPassword: { title: '登入密碼管理' },
    Lottery: { title: '彩券' },
    Notice: { title: '訊息公告' },
    PlayVideo: { title: '影片播放' },
    Setbank: { title: '填寫收款卡' },
    BindCard: { title: '填寫收款卡' },
    Withdraw: { title: '提款' },
    Recharge: { title: '儲值' },
    Personalreport: { title: '個人報表' },
    WithdrawRecord: { title: '提款紀錄' },
    AccountDetail: { title: '帳號明細' },
    GameRecord: { title: '遊戲紀錄' },
  },
  captcha: {
    placeholder: '圖片驗證碼',
    refresh: '點擊重新整理',
    error: '驗證碼錯誤',
    required: '請輸入驗證碼',
  },
  login: {
    title: '登入',
    usernamePlaceholder: '請輸入使用者名稱',
    passwordPlaceholder: '請輸入密碼',
    forgotPassword: '忘記密碼？',
    noAccountRegister: '沒有帳戶？馬上註冊',
    submit: '登入',
  },
  register: {
    title: '註冊',
    usernamePlaceholder: '請輸入使用者名稱(6-12個英文字母或數字)',
    passwordPlaceholder: '請輸入登入密碼(6-12個英文字母或數字)',
    codePlaceholder: '請輸入邀請碼',
    protocol: '我已經知曉並同意"開戶協議"各項條約',
    submit: '註冊',
    codeRequired: '請輸入邀請碼！',
    agreementRequired: '請勾選下方開戶協議！',
  },
}
